import { NotFound } from '../../../pages/ErrorPages/NotFound';
import { routeUrls as routeUrl } from '../RouteUrls';

export function ErrorRoutes() {
  return [{ path: routeUrl.notFound.path, Component: NotFound }];
}
